let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gxMbD")).then(() => parcelRequire('9FW7J'));